import moment from 'moment';
import { ACTION_TYPES } from '../../constants/protocol';

/**
 * Body for POST /audits/ asking the backend to produce an audit-trail PDF.
 * @typedef {Object} AuditTrailPrintPayload
 * @property {'AUDIT_TRAIL'} actionType
 * @property {string[]} [deviceIds]
 * @property {string} deviceType
 * @property {{userIds?: string[], startDate: number, endDate: number}} data  dates in UTC ms
 */

/**
 * @param {{startDate: *, endDate: *, deviceIds?: string[], userIds?: string[]}} searchQuery
 * @param {string} deviceType
 * @returns {AuditTrailPrintPayload}
 */
export const auditTrailPrintPayload = (searchQuery, deviceType) => ({
  actionType: ACTION_TYPES.AUDIT_TRAIL,
  ...(searchQuery.deviceIds && { deviceIds: searchQuery.deviceIds }),
  deviceType,
  data: {
    ...(searchQuery.userIds && { userIds: searchQuery.userIds }),
    startDate: moment(searchQuery.startDate).utc().valueOf(),
    endDate: moment(searchQuery.endDate).utc().valueOf(),
  },
});
